module.exports = __webpack_public_path__ + "media/icons/question-mark-circle-0987cd31.svg";